import React from 'react';
import { ButtonRounded, RadioButton } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import { IconS24Close24 } from '@is24/cosma-ui-icons';
import { useTvsState } from '../../utils/useTvsState';
import IdentificationInfoContent from '../../components/identificationInfoContent/IdentificationInfoContent';

const KybPage: React.FC = () => {
  const { t } = useTranslation();
  const [, setTvsState] = useTvsState();
  const isDarkModeOn = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

  const handleClose = () => {
    setTvsState('');
  };

  const handleDsaVerificationClick = () => {
    window.open(`${process.env.DSA_URL}`, '_blank');
    setTvsState('');
  };

  return (
    <div aria-modal='true' className='modal-backdrop' style={{ zIndex: 2000 }}>
      <div className='modal-container' style={{ width: 601 }}>
        <div className='modal-title-wrapper'>
          <h4 className='modal-headline'>{t('VerificationLandingPage.kybHeading')}</h4>
          <IconS24Close24 onClick={handleClose} data-testid='modal-close-icon' className='tvs-close-button' />
        </div>
        <div className='modal-content-wrapper display-flex'>
          <div className='modal-content palm-display-flex'>
            <div className='grid grid-flex'>
              <IdentificationInfoContent isDarkModeOn={isDarkModeOn} isDsa={true} />
            </div>
            <div className='grid-item font-heading-xsmall-bold margin-top-xxl palm-margin-bottom-none'>
              {t('VerificationLandingPage.availableOptions')}
            </div>
            <div className='grid grid-flex margin-top-xxl gutter-horizontal-m margin-top-m palm-margin-bottom-m palm-margin-top-m'>
              <div className='grid-item one-whole font-h5 verification-option' style={{ cursor: 'pointer' }}>
                <RadioButton label='DSA Verifizierung' id='dsa' name='dsa-verification-method' checked={true} />
              </div>
            </div>
          </div>
        </div>
        <div className='modal-footer verification-modal-footer'>
          <div className='grid grid-flex'>
            <div className='grid-item grid-align-center one-half palm-one-whole'></div>
            <div className='grid-item one-half palm-one-whole'>
              <div className='grid-flex grid-justify-end verification-footer-div palm-one-whole'>
                <ButtonRounded
                  data-testid='veriff-verification-button'
                  className='verification-footer-button'
                  loading={false}
                  label={t('VerificationLandingPage.buttonText')}
                  size={'medium'}
                  onClick={handleDsaVerificationClick}
                ></ButtonRounded>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KybPage;
